export const OrderImportCSV = {
  EU: '/s3/marketplaces/shipstation/OrderImportSampleEU.csv',
  Default: '/s3/marketplaces/shipstation/OrderImportSample.csv',
};
